import { render } from "./CardFix.vue?vue&type=template&id=815afbb2&scoped=true&ts=true"
import script from "./CardFix.vue?vue&type=script&lang=ts"
export * from "./CardFix.vue?vue&type=script&lang=ts"

import "./CardFix.vue?vue&type=style&index=0&id=815afbb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-815afbb2"]])

export default __exports__